import { render, staticRenderFns } from "./EditKeyVault.vue?vue&type=template&id=bf6eb7c0&"
import script from "./EditKeyVault.vue?vue&type=script&lang=js&"
export * from "./EditKeyVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports